<div class="bg-primary text-center">
    <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">{{ 'manufacturingContract' | translate}}</h2>
</div>

<mat-dialog-content class="mat-mdc-dialog-content text-right">
    <div class="container">
        <div class="row w-100">
            <div class="col-md-10">
                <p>انه في يوم <span class="bold">{{DataNow|date:'yyyy/MM/dd'}}</span> اتفق كل من </p>
                <p>
                    الطرف الاول : <span class="pName">{{currentUser?.name}}</span>
                </p>
                <p> الطرق التاني : <span class="pName">{{dataRes.Client?.name}}</span>
                </p>
                <p>
                    علي تصنيع التالي:
                </p>
            </div>
            <div class="col-md-2">
                <img src="../../../../assets/images/PolywinLogo.png" width="100" height="50" />
            </div>
        </div>
        <div class="section">
            <ul *ngFor="let CostCalc of dataRes?.CostCalc;let i=index">
                <li> <span class="spanTitle">{{i+1}}- {{CostCalc?.subCategoryName}}</span></li>
                <li><span class="bold">{{'Area'|translate}} :
                    </span><span>{{ClacArea(CostCalc?.width,CostCalc?.height)}}
                        {{'squareMeter'|translate}}</span>
                </li>
                <li><span class="bold">{{'Color'|translate}} : </span><span>{{CostCalc?.colorName}} </span>
                </li>
                <li><span class="bold">{{'Count'|translate}} : </span><span>{{CostCalc?.count??1}} </span></li>
                <li *ngFor="let product of CostCalc?.typesWithProducts">
                    <span class="bold">{{'Type'|translate}} {{product.productName}}
                        :</span><span>{{product.typeName}}</span>
                </li>
                <li><span class="bold">{{'Price'|translate}} :</span><span>
                        <span>{{CostCalc?.totalPrice}} * {{CostCalc?.count??1}} =
                            {{ClacTotalCost(CostCalc?.totalPrice,CostCalc?.count??1)}}
                            {{'EGP'|translate}}
                        </span>
                    </span>
                </li>

                <li><span class="bold">{{'InstallationDate'|translate}} :
                    </span><span>{{CostCalc.InstallationDate|date:'yyyy/MM/dd'}} </span></li>

                <mat-divider style="margin-bottom: 20px;"></mat-divider>
            </ul>
        </div>
        <p>
            علي ان يتم التسليم والتركيب خلال الأيام المحددة بالأعلى وبإجمالى التكلفة هو :
            <span class="bold"> {{this.dataRes.TotalCost}} {{'EGP'|translate}} </span>
            تدفع علي <span class="bold"> {{dataRes.PaymentsNumber}}</span>
            دفعات
        </p>

        <div class="data" *ngIf="dataRes.PaymentsNumber">
            <table class="table text-center">
                <thead>
                    <tr>
                        <th><span class="headTitle">{{'PaymentValue'|translate}}</span></th>
                        <th><span class="headTitle">{{'PaymentStatus'|translate}}</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let num of PaymentValues">
                        <td>
                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{num}}</mat-label>
                        </td>
                        <td>
                            <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">
                                {{ 'NotPayed'|translate}}
                            </mat-label>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <mat-divider></mat-divider>
    <div class="row m-t-24">
        <div class="col-sm-12 text-left">
            <button mat-button class="Cancelbtn" (click)="onClose()"> {{ 'Cancel' | translate}}</button>
            <button mat-button class="Savebtn" (click)="SaveContractWithClient()"> {{ 'SaveContractWithClient' |
                translate}}</button>
        </div>
    </div>
</mat-dialog-actions>
